import { Messages } from '../../../codegen/Localize';
import { Module } from '../../../ts/Module';
import { GetServerWelcomeChannelInfoRequest, ServerWelcomeChannelInfo } from '../../../ts/ServerApi/requests/GetServerWelcomeChannelInfoRequest';
import { IUpdateServerWelcomeChannelInfoResult, UpdateServerWelcomeChannelInfoRequest } from '../../../ts/ServerApi/requests/UpdateServerWelcomeChannelInfoRequest';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { BaseReactSettingsCtrl, BaseReactSettingsCtrlProps, BaseReactSettingsCtrlScope } from '../../controllers/BaseReactSettingsCtrl';
import { SettingsFormService } from '../../directives/tbSettingsCoordinator';
import WebHttpClient from '../../../httpClient/WebHttpClient';

export interface CustomizationSettingsCtrlProps extends BaseReactSettingsCtrlProps {
  sendUpdateRequest: (defaultBannerEnabled: boolean, serverFooter: string) => ng.IPromise<IUpdateServerWelcomeChannelInfoResult>;
  initialServerWelcomeChannelInfo: ServerWelcomeChannelInfo;
}

export class CustomizationSettingsCtrl extends BaseReactSettingsCtrl<CustomizationSettingsCtrlProps> {

  private static formName: string = 'CustomizationSettingsForm';

  public static $inject = [
    '$scope',
    'SettingsFormService'
  ];

  constructor(
    $scope: BaseReactSettingsCtrlScope<CustomizationSettingsCtrlProps>,
    formService: SettingsFormService,
  ) {
    super($scope, formService, CustomizationSettingsCtrl.formName);

    // Set the tab title
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverSettings_customization()});

    // Setup our one prop
    $scope.props.sendUpdateRequest = this.sendUpdateServerWelcomeChannelInfoRequest.bind(this);

    // Get the initial data from the server
    this.getServerWelcomeChannelInfo().then((result: ServerWelcomeChannelInfo) => {
      $scope.props = {
        ...$scope.props,
        initialServerWelcomeChannelInfo: result
      };
    });
  }

  private getServerWelcomeChannelInfo() {
    return WebHttpClient.sendRequest(new GetServerWelcomeChannelInfoRequest());
  }

  // Handle API requests outside of our React components
  public sendUpdateServerWelcomeChannelInfoRequest(defaultBannerEnabled: boolean, serverFooter: string): Promise<IUpdateServerWelcomeChannelInfoResult> {
    return WebHttpClient.sendRequest(
      new UpdateServerWelcomeChannelInfoRequest({
        welcomeChannelEnabledForServer: defaultBannerEnabled,
        welcomeChannelServerFooter: serverFooter
      })
    );
  }
}

// Remember to register the controller with Angular
Module.instance().controller('CustomizationSettingsCtrl', CustomizationSettingsCtrl);
